/**
 * Grafana library elements share one storage table for both library panels and library variables.
 * `kind` discriminates them. Mirrors `LibraryElementKind` in
 * grafana/pkg/services/libraryelements/model/model.go.
 */
export var GrafanaLibraryElementKind;
(function (GrafanaLibraryElementKind) {
    GrafanaLibraryElementKind[GrafanaLibraryElementKind["Panel"] = 1] = "Panel";
    GrafanaLibraryElementKind[GrafanaLibraryElementKind["Variable"] = 2] = "Variable";
})(GrafanaLibraryElementKind || (GrafanaLibraryElementKind = {}));
//# sourceMappingURL=grafana-library-element.js.map